import { createAsyncThunk } from '@reduxjs/toolkit';
import AssetFolderService from '../../../api/services/AssetFolderService';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../utils/constants';

export const fetchAssetFolders = createAsyncThunk(
  'assetFolder/fetchAssetFolders',
  async ({ influencerId }) => {
    return await AssetFolderService.fetchAssetFolders(influencerId);
  },
  {
    condition: (_, { getState }) => {
      return [
        CRM_ORGANIZATION_MEMBER_ROLE.OWNER,
        CRM_ORGANIZATION_MEMBER_ROLE.ADMINISTRATOR,
        CRM_ORGANIZATION_MEMBER_ROLE.TEAM_LEAD,
        CRM_ORGANIZATION_MEMBER_ROLE.CHATTER,
        CRM_ORGANIZATION_MEMBER_ROLE.CONTENT_MANAGER,
        CRM_ORGANIZATION_MEMBER_ROLE.REVIEWER,
      ].includes(getState().userInfo.user?.role);
    },
  },
);

export const createAssetFolders = createAsyncThunk('assetFolder/createAssetFolders', async requestData => {
  const { name, influencerId } = requestData;
  return await AssetFolderService.createAssetFolders(name, influencerId);
});

export const fetchAssetFolderById = createAsyncThunk('assetFolder/fetchAssetFolderById', async requestData => {
  const { folderId, influencerId } = requestData;
  return await AssetFolderService.fetchAssetFolderById(folderId, influencerId);
});

export const deleteAssetFolder = createAsyncThunk('assetFolder/deleteAssetFolder', async requestData => {
  const { folderId, influencerId } = requestData;
  return await AssetFolderService.deleteAssetFolder(folderId, influencerId);
});

export const editAssetFolder = createAsyncThunk('assetFolder/editAssetFolder', async requestData => {
  const { folderId, name, influencerId } = requestData;
  return await AssetFolderService.editAssetFolder(folderId, name, influencerId);
});

export const addMediaToAssetFolder = createAsyncThunk('assetFolder/addMediaToAssetFolder', async requestData => {
  const { folderId, media, influencerId } = requestData;
  return await AssetFolderService.addMediaToAssetFolder(folderId, media, influencerId);
});

export const removeMediaFromAssetFolder = createAsyncThunk(
  'assetFolder/removeMediaFromAssetFolder',
  async requestData => {
    const { folderId, media, influencerId } = requestData;
    return await AssetFolderService.removeMediaFromAssetFolder(folderId, media, influencerId);
  },
);

export const changeAssetsMediaPositionFolder = createAsyncThunk(
  'assetFolder/changeAssetsMediaPositionFolder',
  async requestData => {
    const { folderId, mediaPositions, influencerId } = requestData;
    return await AssetFolderService.changeAssetsMediaPositionFolder(folderId, mediaPositions, influencerId);
  },
);
